import Bus from '@client/events/bus';
import Context from '@client/events/context';
import events from '@client/events/events';
import store from '@client/store';
import {Logger, Category} from '@simpleinvest/front-end-logger';

const {NEW_BANK_LINKED, BANK_REMOVED, NEW_ACCOUNT_ADDED} = events;

const logger = new Logger({
  category: Category.Accounts,
  fileName: 'userSummary.js',
});

export default {
  register() {
    Bus.$on([NEW_BANK_LINKED, BANK_REMOVED, NEW_ACCOUNT_ADDED], async (payload) => {
      if (!(payload instanceof Context)) {
        return;
      }

      logger.addBreadcrumb({
        callingFuncName: payload.caller,
        message: 'Updating user summary data.',
      });

      await store.dispatch('overview/updateUserSummary', {
        userId: store.getters['cognitoUser/userId'],
      });
    });
  },
};
